//请自行添加语言资源
const delay = {
  msg:{
  }
};
export default delay



// WEBPACK FOOTER //
// ./src/page/report/delay/lang/delay.zh.js